export const s = {
  xxs: 2,
  xs: 4,
  s: 6,
  m: 8,
  l: 10,
  xl: 12,
  xxl: 16,
  xxxl: 24,
  xxxxl: 32,
};
